import enErrors from '@mdvip/shared/locales/en/errors.json';
import enShared from '@mdvip/shared/locales/en/shared.json';
import esErrors from '@mdvip/shared/locales/es/errors.json';
import esShared from '@mdvip/shared/locales/es/shared.json';
import { useUserPreferencesStore } from '@mdvip/shared/stores/userPreferencesStore';
import { createInstance } from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import enProviders from '../locales/en/providers.json';
import esProviders from '../locales/es/providers.json';

export const defaultNS = 'providers' as const;

// Exported so apps/providers/src/types/i18next.d.ts can derive key types from this object
export const resources = {
  'en-US': { shared: enShared, providers: enProviders, errors: enErrors },
  'es-US': { shared: esShared, providers: esProviders, errors: esErrors },
} as const;

const i18n = createInstance();

// Static resources resolve synchronously — no Suspense boundary needed
void i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    lng: useUserPreferencesStore.getState().locale,
    fallbackLng: 'en-US',
    ns: ['shared', 'providers', 'errors'],
    defaultNS,
    resources,
    interpolation: {
      // React already escapes output — double-escaping would corrupt translated strings
      escapeValue: false,
    },
    react: { useSuspense: false },
  });

// Keep i18next in sync when locale preference changes in the store
useUserPreferencesStore.subscribe((state, prevState) => {
  if (state.locale !== prevState.locale) {
    void i18n.changeLanguage(state.locale);
  }
});

export default i18n;
